import React from 'react'

const Card = (props) => {
    return (
        <div className="w-64 h-64 relative rounded-xl hover:rotate-1">
            <img src={props.imgUrl} alt="card-img" className='rounded-xl z-10' />
        </div>
    )
}

export default function Skils() {
    const cardData = [
        { id: 1, imgUrl: require('../../assets/logos/1.png') },
        { id: 2, imgUrl: require('../../assets/logos/2.png') },
        { id: 3, imgUrl: require('../../assets/logos/3.png') },
        { id: 4, imgUrl: require('../../assets/logos/4.png') },
        { id: 5, imgUrl: require('../../assets/logos/6.png') },
        { id: 6, imgUrl: require('../../assets/logos/5.png') },
        { id: 7, imgUrl: require('../../assets/logos/7.png') },
        { id: 8, imgUrl: require('../../assets/logos/8.png') },
    ];
    return (
        <div className='w-full min-h-[85vh] lg:min-h-[78vh]  mt-24  flex justify-center items-center'>
            <div className="flex flex-wrap items-center p-8 gap-x-6 gap-y-4 justify-center ">
                {cardData.map((card) => (
                    <Card key={card.id} imgUrl={card.imgUrl} />
                ))}
            </div>
        </div>
    )
}
